import { render, staticRenderFns } from "./CustomerOriginCell.vue?vue&type=template&id=1413d3fb&"
import script from "./CustomerOriginCell.vue?vue&type=script&lang=js&"
export * from "./CustomerOriginCell.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports